import * as z from 'zod';

export const SpaceHeatingSchema = z.object({
  systems: z.array(z.string()).optional(), // index 0: primary / index 1: secondary
  hasRecoverySystem: z.boolean().optional(),
});

export type SpaceHeating = z.infer<typeof SpaceHeatingSchema>;
